import { Check } from "lucide-react";
import { WHY } from "../data/site";
import { Reveal } from "./Reveal";

export default function WhyChoose() {
  return (
    <section id="about" className="py-24 sm:py-32 bg-[#0D0D0D]" data-testid="why-choose-section">
      <div className="container-lux">
        <Reveal className="max-w-3xl mb-14">
          <p className="overline mb-3">Why Homeowners Choose Us</p>
          <h2 className="font-head text-4xl sm:text-5xl uppercase tracking-tight">
            Twelve reasons to <span className="text-gold-metallic">trust Sterling.</span>
          </h2>
          <p className="mt-4 text-[#C8C8C8]">A family-run business built on honesty, craftsmanship and a genuine care for every home we work on.</p>
        </Reveal>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {WHY.map((w, i) => (
            <Reveal key={w} delay={(i % 4) * 0.06}>
              <div className="glass rounded-sm p-5 flex items-center gap-3 h-full hover:border-[#D4AF37]/50 transition-colors">
                <span className="w-8 h-8 rounded-full bg-[#D4AF37]/10 flex items-center justify-center shrink-0">
                  <Check size={16} className="text-[#D4AF37]" strokeWidth={2} />
                </span>
                <span className="font-head uppercase tracking-tight text-sm sm:text-base">{w}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
